import { action, makeAutoObservable, observable } from "mobx";
import { loadDataHelper } from "./storeHelpers";
import { StoreBaseMethods } from "./storeBase";

class DeliveriesStore {
  host = null
  constructor({ data, host, authTokens } = {}) {
    StoreBaseMethods.copyData(data, this);

    this.authTokens = authTokens;
    this.host = host || data?.host;
    makeAutoObservable(this, undefined, {autoBind: true});
  }
  @observable isLoadingMyDeliveries = false;
  @observable hasLoadedMyDeliveries = false;
  @observable myDeliveries = [];
  @action loadMyDeliveries() {
    return loadDataHelper({
      store: this,
      agentKey: 'Deliveries',
      key: 'MyDeliveries',
    });
  }
}
export default DeliveriesStore;
